import CareGiversGuidePageKK from './ManualUsersGuideFiles/CareGiversGuidePageKK.pdf';
import CareGiversGuidePageRU from './ManualUsersGuideFiles/CareGiversGuidePageRU.pdf';
import ParentsGuidePageKK from './ManualUsersGuideFiles/ParentsGuidePageKK.pdf';
import ParentsGuidePageRU from './ManualUsersGuideFiles/ParentsGuidePageRU.pdf';

const ManualUsersGuideConfig = {
  manualCaregiversUrl: {
    kk: CareGiversGuidePageKK,
    ru: CareGiversGuidePageRU,
  },
  manualParentsUrl: {
    kk: ParentsGuidePageKK,
    ru: ParentsGuidePageRU,
  },
};

export default ManualUsersGuideConfig;
